import useAppSelector from 'common/hooks/useAppSelector';
import { useEffect, useMemo } from 'react';
import useDebouncedState from 'common/hooks/utils/useDebouncedState';
import { FavoritesModalFiltersHash } from '../store/list.types';
import { FavoritesModalFiltersState } from '../store/filter.types';

// exported for use in the initial state
export const filtersHash = (
  state: FavoritesModalFiltersState,
  suffix: string | number = ''
): FavoritesModalFiltersHash =>
  // using template string to match typing
  `${state.currentSort}_${[suffix].join('_')}` as const;

export const useFavoritesModalFiltersIdentifier = (contextId?: string | number): FavoritesModalFiltersHash => {
  const filters = useAppSelector((store) => store.myFavoritesModal.filter);
  const currentIdentifier = useMemo(() => filtersHash(filters, contextId), [filters, contextId]);
  const [appliedIdentifier, setAppliedIdentifier] = useDebouncedState(currentIdentifier, 500);
  useEffect(() => {
    setAppliedIdentifier(currentIdentifier);
  }, [currentIdentifier]);
  return appliedIdentifier;
};
